import { createFileRoute, useRouter, useSearch } from '@tanstack/react-router'
import { useAtom } from 'jotai'
import { useEffect } from 'react'

import { useGetAllClients } from '@/gen/publicApi'

import Spinner from '@/components/spinner'

import { clientCodeAtom } from '@/state/clientCode'

import ClientSelector from './-components/clientSelector'

export const Route = createFileRoute('/_authed/')({
    component: ClientSelectorComponent,
})

function ClientSelectorComponent() {
    const [clientCode, setClientCode] = useAtom(clientCodeAtom)
    // Haven't put in pagination here yet. If someone has more than 500 clients
    // then we can figure this out then
    const { data: clients } = useGetAllClients({
        Limit: 500,
    })
    const router = useRouter()
    const queryParams = useSearch({ strict: false }) as any
    const doReselect = queryParams.reselect !== undefined

    useEffect(() => {
        if (clientCode && !doReselect) {
            // Got a client code in state and we're not reselecting. Just redirect
            // to the client's homepage. Unsure why the brief delay is needed
            setTimeout(() => router.history.push(`/${clientCode}`), 100)
        }
    }, [clientCode, doReselect, router, setClientCode])

    useEffect(() => {
        if (!clientCode && clients?.data?.length === 1) {
            // Only one client, save it as default
            setClientCode(clients.data[0].code)
            router.history.push(`/${clients.data[0].code}`)
        }
    }, [clientCode, clients?.data, router, setClientCode])

    if (!clientCode && clients?.data?.length === 1) {
        // No client code and there is only a single client. Show loader until we
        // set the client in the atom via useEffect
        return <Spinner size="sm" absolute />
    }

    if (!clients?.data) {
        // No client data yet. If we never get the data then this will be an
        // infinite spinner
        return <Spinner size="sm" absolute />
    }

    if (!clientCode || doReselect) {
        // If we get here we've got multiple clients or it's an explicit client
        // reselection. Let the user select another client
        return <ClientSelector clients={clients.data} />
    }

    return <Spinner size="sm" absolute />
}
